// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Vr-z","tooltipWrapper":"Wr-z","icon":"Xr-z","tooltip":"Yr-z","content":"Zr-z"};